import { render, staticRenderFns } from "./temcenter4.vue?vue&type=template&id=2b977752&scoped=true"
import script from "./temcenter4.vue?vue&type=script&lang=js"
export * from "./temcenter4.vue?vue&type=script&lang=js"
import style0 from "./temcenter4.vue?vue&type=style&index=0&id=2b977752&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b977752",
  null
  
)

export default component.exports